<template>
  <div class="case">
    <div class="topImg row">
      <div class="col-md-12">
        <img
          style="object-fit: cover;"
          :src="data.nav_pic"
          alt="南京小程序开发"
          title="南京小程序开发"
        />
        <div class="texts">
          <div>{{ data.nav_title }}</div>
          <div>{{ data.nav_desc }}</div>
        </div>
      </div>
    </div>
    <div class="newsData">
      <div class="container">
        <div class="row">
          <div class="col-sm-6 col-md-4" v-for="(item, index) in caseData">
            <div
              :class="item.rotate ? 'thumbnail showData' : 'thumbnail hideData'"
              @click="start(item.id)"
            >
              <div :class="item.rotate ? 'show-pond' : 'no-pond'">
                <!--正面展示-->
                <img
                  :src="item.imgUrl"
                  alt="南京小程序开发"
                  title="南京小程序开发"
                />
                <!-- <img
                  :src="item.imgUrl + '-mokyun_site_case_cover_b'"
                  alt="南京小程序开发"
                  title="南京小程序开发"
                /> -->
                <div
                  class="caption"
                  :style="index === 0 ? 'padding: 8px 9px;' : ''"
                >
                  <div>
                    <div class="title">{{ item.name }}</div>
                    <div class="text">{{ item.desc }}</div>
                  </div>
                </div>
              </div>

              <div
                :class="item.rotate ? 'no-pond opposite' : 'show-pond opposite'"
              >
                <!--背面展示-->
                <div
                  class="img-code"
                  style="display:flex;justify-content: center;align-items: center;"
                >
                  <img
                    :src="item.qrcode"
                    style="max-width:200px;max-height:200px"
                    :alt="index % 2 == 0 ? '南京小程序开发' : '南京小程序开发'"
                    :title="
                      index % 2 == 0 ? '南京小程序开发' : '南京小程序开发'
                    "
                  />
                </div>

                <div class="project-text">
                  <div class="box">
                    <div>{{ item.name }}</div>
                    <div></div>
                    <p>{{ item.desc }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 100%;padding-right: 15px;padding-left: 15px;">
          <div class="seeMore" @click="seeMore">
            {{ moreText }}
          </div>
        </div>

        <el-dialog :visible.sync="showMessage">
          <div
            class="show-box"
            style="width: 100%;  overflow-y: auto; height:79vh;"
          >
            <img
              style="width: 100%;"
              :src="showImg"
              alt="南京小程序开发"
              title="南京小程序开发"
            />
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import getData from '../api/getInfo';
import layer from 'vue-layer';

export default {
  data() {
    return {
      caseData: [],
      paging: { size: 9, page: 1 },
      data: {},
      rotate: false,
      moreText: '查看更多',
      more: false,
      morList: [],
      showMessage: false,
      showImg: '',
    };
  },
  mounted() {
    this.separate();
    this.getCase(this.paging.size, this.paging.page);

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    var _hmt = _hmt || [];
    (function() {
      var hm = document.createElement('script');
      hm.src = 'https://hm.baidu.com/hm.js?75d1af96b450c5590fffaae8357a65e0';
      var s = document.getElementsByTagName('script')[0];
      // s.parentNode.insertBefore(hm, s)

      // var bp = document.createElement('script');
      var curProtocol = window.location.protocol.split(':')[0];
      if (curProtocol === 'https')
        hm.src = 'https://zz.bdstatic.com/linksubmit/push.js';
      else hm.src = 'http://push.zhanzhang.baidu.com/push.js';
      // var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();
    document.body.addEventListener(
      'click',
      (e) => {
        this.caseData.forEach((v, index) => {
          this.caseData[index].rotate = false;
        });
        return false;
      },
      true,
    );
  },
  methods: {
    // 获取优质案例
    getCase(size, page) {
      let showList = [
        {
          id: '32',
          name: '保粹评级',
          info: '拍卖类解决方案',
          pic: '1586835503740',
          desc:
            '拍卖行业的垂直解决方案，提供包括产品上拍、产品竞拍、拍品鉴别、拍品验证等多维度服务',
          sort: '0',
          label: '商城',
          qrcode: 'https://cdn1-open.mokyun.com/FgVSB4JDfdvPQElnuntnvPPqO_Zg',
          appid: '23',
          imgUrl: 'https://cdn1-open.mokyun.com/FgVSB4JDfdvPQElnuntnvPPqO_Zg',
          detailUrl:
            'https://cdn1-open.mokyun.com/loUfbfBw5_HmN1G6SLSErNPBIl0Q',
        },
        {
          id: '8',
          name: '云鼎汇',
          info: '家具商城类解决方案',
          pic: '1539655819598',
          desc:
            '家具商城类解决方案，从用户选购热门产品，新品，挑选详细类别商品，全方位服务',
          sort: '1',
          label: '商城',
          qrcode: 'https://cdn1-open.mokyun.com/FmDH_2M0dJX0iEeh4VAA3p6Ppfj-',
          imgUrl: 'https://cdn1-open.mokyun.com/FmDH_2M0dJX0iEeh4VAA3p6Ppfj-',
          appid: '23',
          detailUrl:
            'https://cdn1-open.mokyun.com/luoYSPWQGXAZu2w0TM_NJ2m0GsTr',
        },
        {
          id: '9',
          name: '聚能签',
          info: '旅游行业智慧签证解决方案',
          pic: '1539655853564',
          desc:
            '专业的签证类解决方案，从用户发起签证，到用户落地海外地区，每一个流程都尽在掌握中。全方位的服务，无纸化的体验。',
          sort: '2',
          label: '服务',
          qrcode: 'https://cdn1-open.mokyun.com/FgyyahmcgWRIGsMyCLNtBer1iDnW',
          appid: '23',
          imgUrl: 'https://cdn1-open.mokyun.com/FgyyahmcgWRIGsMyCLNtBer1iDnW',
          detailUrl:
            'https://cdn1-open.mokyun.com/lhh-ykz-zKGC3U4ctqalsKGUO8RT',
        },
        {
          id: '2',
          name: '天津阳光',
          info: '地产行业解决方案',
          pic: '1539655661124',
          desc:
            '地产行业解决方案，提供包括热销楼盘、房贷计算，购房政策等服务，为用户提供便捷的购房体验',
          sort: '3',
          label: '服务',
          qrcode: 'https://cdn1-open.mokyun.com/FsNkU99OOSiKyGod0GRQM1JPyLTz',
          imgUrl: 'https://cdn1-open.mokyun.com/FsNkU99OOSiKyGod0GRQM1JPyLTz',
          appid: '23',
          detailUrl:
            'https://cdn1-open.mokyun.com/loTmW1h1kxXrQIf7G9WLOpq2FNF8',
        },

        {
          id: '5',
          name: '高科置业',
          info: '物业服务行业解决方案',
          pic: '1539655735311',
          desc:
            '物业服务行业解决方案，提供报修，反馈，活动等服务，为业主提供便捷的生活服务',
          sort: '4',
          label: '服务',
          qrcode: 'https://cdn1-open.mokyun.com/Fn5zUa4NaHOg3okRZpdPYtGBnWbD',
          imgUrl: 'https://cdn1-open.mokyun.com/Fn5zUa4NaHOg3okRZpdPYtGBnWbD',
          appid: '23',
          detailUrl:
            'https://cdn1-open.mokyun.com/lqUAeKQ8PGoUtKrHsaCPlQUGACVu',
        },

        {
          id: '1',
          name: '泰通科技',
          info: '企业公众号解决方案',
          pic: '1539655632523',
          desc: '企业公众号解决方案 ，公众号消息，公众号服务，个人中心',
          sort: '4',
          label: '公众号',
          qrcode: 'https://cdn1-open.mokyun.com/Fi093hrJOMYsVS4HxT2WTkz8kZOV',
          imgUrl: 'https://cdn1-open.mokyun.com/Fi093hrJOMYsVS4HxT2WTkz8kZOV',
          appid: '23',
          detailUrl:
            'https://cdn1-open.mokyun.com/lq-izjkOBXyziiVJu4Qq-1AKY5pN',
        },
      ];

      showList.forEach((val, index) => {
        this.caseData.push(val);
      });
      this.caseData.forEach((list, index) => {
        this.caseData[index].rotate = false;
      });
    },

    // 获取顶部图文信息
    separate() {
      let list = [
        {
          id: '1',
          nav_title: '解决方案',
          nav_pic: '1541475369769',
          nav_desc:
            '关注生活所关注的，了解商业所了解的，我们所做的一切，只是为了让科技改变生活。',
          sort: '6',
          appid: '23',
        },
        {
          id: '2',
          nav_title: '案例展示',
          nav_pic: '1541475386238',
          nav_desc:
            '根据行业现状按需定制，不做任何无用功，我们做的就是您想要的。',
          sort: '5',
          appid: '23',
        },
        {
          id: '6',
          nav_title: '功能',
          nav_pic: '1541488820596',
          nav_desc: '功能模块',
          sort: '4',
          appid: '23',
        },
        {
          id: '5',
          nav_title: '实验室',
          nav_pic: '1541475376231',
          nav_desc:
            '根据行业现状按需定制，不做任何无用功，我们做的就是您想要的。',
          sort: '3',
          appid: '23',
        },
        {
          id: '3',
          nav_title: '联系我们',
          nav_pic: '1541475595720',
          nav_desc:
            '去繁就简，留给你最好的体验，始终坚持契约精神，给我们一个机会，我们只会让你喜出望外。',
          sort: '2',
          appid: '23',
        },
        {
          id: '4',
          nav_title: '加入我们',
          nav_pic: '154147535974',
          nav_desc:
            '我们不仅仅是想做好研发，我们更想为这个蓬勃的互联网行业持续注入，开源精神，我们一直都在。',
          sort: '1',
          appid: '23',
        },
      ];
      list.forEach((v) => {
        if (v.nav_title == '案例展示') {
          this.data = v;
          this.data.nav_pic = `${getData.url}${v.nav_pic}`;
        }
      });
    },

    async start(id) {
      await this.caseData.map((v) => {
        if (v.id === id) {
          this.showImg = v.detailUrl;
        }
      });

      this.caseData = JSON.parse(JSON.stringify(this.caseData)); // 解决办法

      this.showMessage = true;
    },

    // 点击加载更多
    seeMore() {
      if (this.more) {
        this.moreText = '没有更多了';
        return this.$message({
          message: '没有更多了',
          type: 'warning',
        });
      }
      const list = [
        {
          id: '31',
          name: '掌控好房',
          info: '购房解决方案',
          pic: '1548829196491',
          desc:
            '独具特色的购房模式，从预售楼盘、开盘楼盘、购房新闻等多方面入手，打造完善的特色购房平台。',
          sort: '6',
          label: '服务',
          qrcode:
            '1548https://cdn1-open.mokyun.com/FtckcxYe5s_gN7ayis92Qz-TWgmr829154833',
          imgUrl: 'https://cdn1-open.mokyun.com/FtckcxYe5s_gN7ayis92Qz-TWgmr',
          appid: '23',
          detailUrl:
            'https://cdn1-open.mokyun.com/lpYzzk-VbF6JraIvWqB30iVFqEW-',
        },
      ];

      list.forEach((val, index) => {
        this.morList.push(val);
      });
      this.morList.forEach((list, index) => {
        // this.morList[index].imgUrl = `${getData.url}${list.pic}`;
        // this.morList[index].qrcode = `${getData.url}${list.qrcode}`;
        this.morList[index].rotate = false;
      });

      this.morList.forEach((val) => {
        this.caseData.push(val);
      });
      this.more = true;
    },
  },
};
</script>

<style scoped>
body {
  padding-right: 0 !important;
  padding-left: 0 !important;
  /* overflow: hidden; */
  overflow-y: auto;
}
>>> .el-dialog__header {
  padding: 0px !important;
}
>>> .el-dialog__body {
  padding: 0px !important;
}

.case {
  width: 100%;
  background: #fafafa;
}
.row {
  margin: 0;
  padding: 0;
}
.topImg {
  width: 100%;
}
.topImg .col-md-12 {
  width: 100%;
  padding: 0;
  position: relative;
}
.topImg img {
  width: 100%;
  height: 100%;
}
.topImg .texts {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
}
.topImg .texts > div {
  width: 100%;
  text-align: center;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.topImg .texts > div:nth-child(1) {
  height: 60%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 8px;
  font-size: 50px;
  font-family: '黑体';
  font-weight: 600;
}
.topImg .texts > div:nth-child(2) {
  height: 40%;
  font-size: 15px;
  font-family: '黑体';
}
@media only screen and (min-width: 1100px) and (max-width: 1400px) {
  .topImg .texts > div:nth-child(1) {
    font-size: 3rem;
  }
  .topImg .texts > div:nth-child(2) {
    font-size: 13px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1100px) {
  .topImg .texts > div:nth-child(1) {
    font-size: 2rem;
  }
  .topImg .texts > div:nth-child(2) {
    font-size: 12px;
  }
}
@media only screen and (min-width: 768px) {
  .topImg {
    margin-top: 51px;
  }
}
@media only screen and (max-width: 768px) {
  .topImg .texts > div:nth-child(1) {
    font-size: 1.5rem;
  }
  .topImg .texts > div:nth-child(2) {
    font-size: 10px;
    padding: 0 12px;
  }
  .topImg {
    margin-top: 53px;
  }
}

@media only screen and (max-width: 768px) and (min-width: 680px) {
  .topImg .col-md-12 {
    height: 100px;
  }
  >>> .el-dialog {
    width: 70% !important;
  }
}
@media only screen and (max-width: 680px) and (min-width: 460px) {
  .topImg .col-md-12 {
    height: 80px;
  }
  >>> .el-dialog {
    width: 80% !important;
  }
}
@media (max-width: 460px) {
  .topImg .col-md-12 {
    height: 170px;
    object-fit: cover;
  }
  >>> .el-dialog {
    width: 80% !important;
  }
}
.newsData {
  width: 100%;
  padding: 2.5em 0;
}
.newsData .container {
  width: 75%;
  min-height: 300px;
  transition: all 0.8s ease-in-out;
}

@media only screen and (max-width: 768px) and (min-width: 580px) {
  .newsData .container {
    width: 75% !important;
    padding: 0;
  }
}

@media only screen and (max-width: 580px) and (min-width: 450px) {
  .newsData .container {
    width: 85% !important;
    padding: 0;
  }
  >>> .el-dialog {
    width: 80% !important;
  }
}

@media only screen and (max-width: 450px) and (min-width: 310px) {
  .newsData .container {
    width: 100% !important;
    padding: 0;
  }
  >>> .el-dialog {
    width: 80% !important;
  }
}

@media only screen and (max-width: 310px) {
  .newsData .container {
    width: 100% !important;
    padding: 0;
  }
  >>> .el-dialog {
    width: 80% !important;
  }
}

.newsData .container .caption > div {
  width: 90%;
  margin: 0 auto;
}
.newsData .container .caption > div .title {
  width: 100%;
  font-family: 'MicrosoftYaHei';
  font-size: 20px;
  line-height: 40px;
  color: #343434;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.newsData .container .caption > div .text {
  width: 100%;
  min-height: 7em;
  font-family: 'MicrosoftYaHei';
  font-size: 14px;
  line-height: 24px;
  color: #888;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
.newsData .container .row {
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0;
}
/*.newsData .container .col-md-4:hover{
	transition: all .8s ease-in-out;
	transform: scale(1.01);
}*/
.newsData .container .col-md-4 .thumbnail {
  position: relative;
  padding: 0;
}
.newsData .container .col-md-4 .thumbnail img {
  width: 100%;
}
.newsData .container .col-md-4 .thumbnail:hover {
  /*box-shadow: 0px 8px 38px 0px
		rgba(94, 114, 169, 0.15);
	cursor:pointer;
	text-shadow: 5px 5px 10px #bbb;
	transition: all .8s;*/
  /*animation: overturn 5s ease-out;*/
  transition: all 1.2s;
  cursor: pointer;
  /*transform: rotateY(180deg);*/
}
.newsData .container .col-md-4 .hideData {
  transition: all 2s;
  transform: rotateY(0deg);
}
.newsData .container .col-md-4 .showData {
  transform: rotateY(180deg);
  transition: all 2s;
}
.newsData .container .col-md-4 .thumbnail .show-pond {
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: all 1s;
}
.newsData .container .col-md-4 .thumbnail .no-pond {
  width: 100%;
  height: 100%;
  opacity: 1;
  transition: all 1s;
}
.newsData .container .col-md-4 .thumbnail .opposite {
  position: absolute;
  top: 0;
  left: 0;
  transform: rotateY(180deg);
  background: #5d84f3;
  border-radius: 4px;
  overflow: hidden;
}
.thumbnail .opposite .img-code {
  width: 100%;
  height: 66.5%;
}
.thumbnail .opposite .project-text {
  width: 100%;
}
.thumbnail .opposite .project-text .box {
  width: 85%;
  height: 70%;
  margin: 20px auto 0;
}
.project-text .box div {
  width: 100%;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 1px;
}
.project-text .box div:nth-child(2) {
  width: 20%;
  height: 4px;
  background: #9fb5f8;
  margin: 5px 0 10px;
  border-radius: 20px;
}
.project-text .box p {
  width: 100%;
  color: #fff;
  font-size: 14px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.newsData .container .col-md-4 .hideMoudel {
  width: 100%;
  height: 100%;
  /*background: red;*/
  /*display: none;*/
  position: absolute;
  top: 0;
  left: 0;
}
.newsData .container .col-md-4 .animated {
}
/*@keyframes overturn {
	from{color: #fff;}
	to{color: orange;}
}*/
.seeMore {
  width: 100%;
  min-height: 60px;
  background: #fff;
  margin: 0 auto;
  text-align: center;
  color: #343434;
  font-family: 'MicrosoftYaHei';
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.2);
  border: solid 1px #eeeeee;
  margin-bottom: 40px;
  border-radius: 5px;
}

.bottom {
  width: 100%;
  background: #343434;
  color: white;
}
.bottom .container {
  width: 100%;
  height: 100%;
}
.bottom .container .us {
  width: 80%;
  margin: 0 auto;
  padding: 4.5em 0;
}
.bottom .container .us .col-md-2 img {
  width: 40%;
  height: 40%;
}
.bottom .container .us > div {
  margin-bottom: 2em;
}
.bottom .container .us .titleText {
  font-family: MicrosoftYaHei;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 0px;
  color: rgba(255, 255, 255, 0.9);
  opacity: 0.9;
  margin-bottom: 1.1em;
}
.bottom .container .us > div > div > div:nth-child(2) {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 0px;
  color: #cdcdcd;
}

footer {
  width: 100%;
  /*height: 85px;*/
  min-height: 85px;
  background: #222;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
}
footer > div {
  font-family: 'microsoft yahei';
  font-size: 14px;
  line-height: 24px;
  color: #e1e1e1;
}
</style>



// WEBPACK FOOTER //
// src/view/show.vue